export class ItemCalcBy {
    static None = 0;
    static Balance = 1;
    static Standard = 2;


    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}